/*
 * Mutations for the [energy_management_systems store]{link module:store/energy_management_systems}
 *
 * @module store/energy_management_systems/mutations
 */

/*
 * Mutation to reset the ems store
 *
 * @function
 *
 */
export function RESET_EMSS(state) {
  state.emsGroups = {}
  state.emss = {}
  state.users = {}
}

/*
 * Mutation to add/replace an EMS {object} into the store
 *
 * Adds the EMS into store.emss
 * Will replace the ems information in case the ID is already existing
 *
 * @function
 *
 * @param {object} ems has to be an [Ems]{@link module:store/energy_management_systems.Ems}
 *
 */
export function SET_EMS(state, ems) {
  state.emss[ems.id] = ems
}

/*
 * Mutation to add/replace all EMSs {object} in the store
 *
 * Sets the EMSs into store.emss
 * Will always replace any store.emss entries
 *
 * @function
 *
 * @param {object} emss is a hash of EMSs with mapping `emsId => Ems`` including any EMS information
 *
 */
export function SET_EMSS(state, emss) {
  for (var emsId of Object.keys(emss)) {
    state.emss[emsId] = emss[emsId]
  }
}

/*
 * Mutation to add/replace EMS relations for a User
 *
 * Adds the emsIds into store.users[userId]
 * Will replace the emsIds in case the ID is already existing
 *
 * @function
 *
 * @param {Integer} userId is the id of the observed User
 * @param Array{Integer} emsIds is a list of all EmsIDs related to the user
 *
 */
export function SET_EMSS_FOR_USER(state, { userId, emsIds }) {
  state.users[userId] = emsIds
}

/*
 * Mutation to add/replace EMS relations for an EmsGroup
 *
 * Adds the emsIds into store.emsGroups[groupId]
 * Will replace the emsIds in case the group ID is already existing
 *
 * @function
 *
 * @param {Integer} groupId is the id of the observed emsGroup
 * @param {Array} emsIds is a list of all EmsIDs related to the emsGroup
 *
 */
export function SET_EMSS_FOR_GROUP(state, { groupId, emsIds }) {
  state.emsGroups[groupId] = emsIds
}

/*
 * Mutation to add EMS relations for an EmsGroup
 *
 * Adds the emsId into store.emsGroups[groupId]
 *
 * @function
 *
 * @param {Integer} groupId is the id of the observed emsGroup
 * @param {Array} emsId is a EmsID related to the emsGroup
 *
 */
export function ADD_EMS_TO_GROUP(state, { groupId, emsId }) {
  if (state.emsGroups[groupId]) {
    state.emsGroups[groupId].push(emsId)
  } else {
    state.emsGroups[groupId] = [emsId]
  }
  state.emsGroups[groupId] = [...new Set(state.emsGroups[groupId])]
}

/*
 * Mutation to remove EMS relations for an EmsGroup
 *
 * Removes the emsId from store.emsGroups[groupId]
 *
 * @function
 *
 * @param {Integer} groupId is the id of the observed emsGroup
 * @param {Array} emsId is a EmsID related to the emsGroup
 *
 */
export function REMOVE_EMS_FROM_GROUP(state, { groupId, emsId }) {
  if (state.emsGroups[groupId]) {
    state.emsGroups[groupId] = state.emsGroups[groupId].filter((id) => {
      return id !== emsId
    })
  }
}
